import { createContext, useContext, useMemo, useState, useRef } from "react";

import useCentralLogics from "./useCentralLogics";
import useCentralLogicsKeyboard from "./useCentralLogicsKeyboard";
import useCentralLogicsMouse from "./useCentralLogicsMouse";
import useIOSSE from "./useIOSSE";

export const JoinedMeetingScreenIOContext = createContext();

export const useScreenIO = () => {
  const context = useContext(JoinedMeetingScreenIOContext);
  if (!context) throw new Error("useScreenIO must be used within a JoinedMeetingScreenIOContextProvider");
  return context;
};

export default function JoinedMeetingScreenIOContextProvider({ children }) {
  const [IOWSEnabledForDebugging, setIOWSEnabledForDebugging] = useState(false);

  const [
    localRequestingMouseControlScreenId,
    setLocalRequestingMouseControlScreenId,
    backendReportingMouseControls,
    setBackendReportingMouseControls,
    userHasRequestedMouse,
    userHasMouse,
    lastSentMouseCommand,
    requestMouseControl,
    releaseMouseControl,
    sendMouseCommand,
    setMouseIconState,
  ] = useCentralLogics("mouse", IOWSEnabledForDebugging);

  useCentralLogicsMouse({
    userHasMouse,
    sendMouseCommand,
    setMouseIconState,
  });

  const [
    localRequestingKeyboardControlScreenId,
    setLocalRequestingKeyboardControlScreenId,
    backendReportingKeyboardControls,
    setBackendReportingKeyboardControls,
    userHasRequestedKeyboard,
    userHasKeyboard,
    lastSentKeyboardCommand,
    requestKeyboardControl,
    releaseKeyboardControl,
    sendKeyboardCommand,
    setKeyboardIconState,
  ] = useCentralLogics("kybd", IOWSEnabledForDebugging);

  useCentralLogicsKeyboard({
    userHasKeyboard,
    sendKeyboardCommand,
    setKeyboardIconState,
  });

  const IOEventSourceRef = useRef();
  useIOSSE({
    IOEventSourceRef,

    setBackendReportingMouseControls,
    setLocalRequestingMouseControlScreenId,
    localRequestingMouseControlScreenId,

    setBackendReportingKeyboardControls,
    setLocalRequestingKeyboardControlScreenId,
    localRequestingKeyboardControlScreenId,
  });

  const contextValue = useMemo(
    () => ({
      IOWSEnabledForDebugging,
      setIOWSEnabledForDebugging,

      backendReportingMouseControls,
      userHasRequestedMouse,
      userHasMouse,
      lastSentMouseCommand,
      requestMouseControl,
      releaseMouseControl,

      backendReportingKeyboardControls,
      userHasRequestedKeyboard,
      userHasKeyboard,
      lastSentKeyboardCommand,
      requestKeyboardControl,
      releaseKeyboardControl,
    }),
    [
      IOWSEnabledForDebugging,

      backendReportingMouseControls,
      userHasRequestedMouse,
      userHasMouse,
      lastSentMouseCommand,
      requestMouseControl,
      releaseMouseControl,

      backendReportingKeyboardControls,
      userHasRequestedKeyboard,
      userHasKeyboard,
      lastSentKeyboardCommand,
      requestKeyboardControl,
      releaseKeyboardControl,
    ],
  );

  return <JoinedMeetingScreenIOContext.Provider value={contextValue}>{children}</JoinedMeetingScreenIOContext.Provider>;
}
